import InputSelect from "../InputSelect";
import { useState, useContext, useEffect } from "react";
import GlobalContext from "../../context/GlobalContext";
import { fetchSelectPersonnels } from "../../api/UsersApi";
import defaultProfile from "../../assets/images/icon/default_profile.jpeg";
import { components as ReactSelectComponents } from "react-select";

import { tr } from "../../i18n";
const SelectPersonnel = (props) => {
  const { user } = useContext(GlobalContext);
  const [options, setOptions] = useState([]);
  const [defaultOption, setDefaultOption] = useState(null);

  const customComponents = {
    // Gambar profil saat sudah dipilih
    SingleValue: (props) => (
      <ReactSelectComponents.SingleValue {...props}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={props.data.picture || "/default-profile.png"}
            alt="profile"
            onError={(e) => (e.target.src = defaultProfile)}
            style={{ width: 24, height: 24, borderRadius: "50%", marginRight: 8 }}
          />
          {props.data.label}
        </div>
      </ReactSelectComponents.SingleValue>
    ),
    // Gambar profil di setiap opsi
    Option: ({ data, innerRef, innerProps }) => (
      <div
        className="react-custom-single-value"
        ref={innerRef}
        {...innerProps}
        style={{ display: "flex", alignItems: "center", padding: "10px" }}
      >
        <img
          src={data.picture || "/default-profile.png"}
          alt="profile"
          onError={(e) => (e.target.src = defaultProfile)}
          style={{ width: 24, height: 24, borderRadius: "50%", marginRight: 8 }}
        />
        {data.label}
      </div>
    ),
  };

  const data = {
    name: props.name,
    className: props.className,
    rules: props.rules,
    components: customComponents,
    placeholder: tr("users:choose_staff"),
    options: options,
    key: null,
    label: props.label,
    defaultValue: defaultOption,
    disabled: props.disabled,
    isMulti: props.isMulti,
  };

  const fetchData = async (keyword = "", defaultValue = "") => {
    try {
      const dataList = await fetchSelectPersonnels(
        user.workspace.company_id,
        keyword,
        defaultValue
      );

      if (defaultValue) {
        return dataList;
      } else {
        return dataList.data.map((data) => ({
          label: String(data.text),
          value: String(data.id),
          picture: data.picture,
        }));
      }
    } catch (error) {
      console.error("Error fetching personnels", error);
      return [];
    }
  };

  useEffect(() => {
    const loadInitialData = async () => {
      const isValidOption = (opt) =>
        opt && typeof opt === "object" && "value" in opt && "label" in opt;

      if (props.defaultValue) {
        if (Array.isArray(props.defaultValue)) {
          if (props.defaultValue.every(isValidOption)) {
            setDefaultOption(props.defaultValue);
          }
        } else {
          const defaultData = await fetchData("", props.defaultValue);
          if (defaultData?.data?.[0]) {
            setDefaultOption(defaultData.data[0]);
          }
        }
      }
    };

    loadInitialData();
  }, [props.defaultValue, user.workspace.company_id]);

  async function handleData(search = "") {
    const result = await fetchData(search);

    return result; // Pastikan ini array, bukan Promise
  }

  return (
    <div
      className="select-container"
      style={{ textAlign: "left", width: "100%" }}
    >
      <InputSelect
        data={data}
        handleChange={() => {}}
        handleOnLoadData={handleData}
        components={customComponents}
      />
    </div>
  );
};

export default SelectPersonnel;
